const UpdateOperators = {
  set: 1,
  push: 2,
};

const WriteOperations = {
  insert: 1,
  insertMany: 2,
  updateInsert: 3,
  updateInsertMany: 4,
  update: 5,
};

const DefectConstants = {
  amountType: {
    NONE: 1,
    MRP: 2,
    INVOICE: 3,
    DIRECT_COMPUTE: 4,
  },
};

const userNotifiers = {
  PASSWORD_EXPIRED: 'Password Expired'
}

module.exports = {
  DefectConstants,
  UpdateOperators,
  WriteOperations,
  userNotifiers
};
